import { __awaiter, __decorate, __extends, __generator, __metadata, __param } from "tslib";
import { PasswordRepository } from '../../../repository/password';
import { Entity } from '../../../../base/ddd-types/entity';
import { INetworkRequestService } from '../../../../base/request/network-request.interface';
var PasswordEntity = /** @class */ (function (_super) {
    __extends(PasswordEntity, _super);
    function PasswordEntity(networkRequestService, tinyid) {
        var _this = _super.call(this, tinyid) || this;
        _this.networkRequestService = networkRequestService;
        _this.phone = '';
        _this.isHasPassword = false;
        _this.pwdQuestionList = [];
        _this.passwordRepository = new PasswordRepository(_this.networkRequestService);
        return _this;
    }
    PasswordEntity.prototype.updatePwdTips = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.passwordRepository.pwdTipsGet()];
                    case 1:
                        resData = (_d.sent()).resData;
                        this.isHasPassword = !!((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.hasPwd);
                        this.phone = (_c = (_b = resData === null || resData === void 0 ? void 0 : resData.data) === null || _b === void 0 ? void 0 : _b.pwdPhoneNum) !== null && _c !== void 0 ? _c : '';
                        return [2 /*return*/];
                }
            });
        });
    };
    PasswordEntity.prototype.updatePwdQuestionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.passwordRepository.pwdQuestionGet()];
                    case 1:
                        resData = (_c.sent()).resData;
                        this.pwdQuestionList = (_b = (_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.questionInfo) !== null && _b !== void 0 ? _b : [];
                        return [2 /*return*/];
                }
            });
        });
    };
    PasswordEntity = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String])
    ], PasswordEntity);
    return PasswordEntity;
}(Entity));
export { PasswordEntity };
